import { render } from "./InviteCollaboratorForm.vue.js?vue&type=template&id=48eb82b8!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./InviteCollaboratorForm.vue?vue&type=template&id=48eb82b8"
import script from "./InviteCollaboratorForm.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./InviteCollaboratorForm.vue?vue&type=script&lang=js"
export * from "./InviteCollaboratorForm.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./InviteCollaboratorForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/Web/scripts/components/publication/InviteCollaboratorForm.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "48eb82b8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('48eb82b8', __exports__)) {
    api.reload('48eb82b8', __exports__)
  }
  
  module.hot.accept("./InviteCollaboratorForm.vue.js?vue&type=template&id=48eb82b8!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./InviteCollaboratorForm.vue?vue&type=template&id=48eb82b8", () => {
    api.rerender('48eb82b8', render)
  })

}


export default __exports__